import styles from './ChangePD.module.css'
import moment from "moment";
import MainFormTemplate from "../../../FormTemplate/MainFormTemplate/MainFormTemplate";
import ModalWindow from "../../../FormTemplate/ModalWindow/ModalWindow";
import ButtonContainer from "../../../FormTemplate/ButtonContainer/ButtonContainer";
import React, {useRef, useState} from "react";
import InputItem, {IRefInputItem} from "../../../FormTemplate/InputItem/InputItem";
import InputItemLight from "../../../FormTemplate/InputItemLight/InputItemLight";
import ErrorLineItem, {ErrorLineItemRef} from "../../../FormTemplate/ErrorLineItem/ErrorLineItem";
import useApiQuery from "../../../ApiQuery/UseApiQuery";

interface IUpdateItem
{
    dkpId:number
    family:string
    name:string
    middleName?:string

    birthDate:Date

    serial:string
    number:string

    depart:string
    docDate:Date

}


interface IPDData
{
    family:string
    name:string
    middleName?:string

    birthDate:string

    serial:string
    number:string

    depart:string
    docDate:string

}


interface IChangePDProps
{
    onClose:()=>void
    dkpId:number
    onSuccess:()=>void
    data?:IPDData

}

export default function ChangePD({dkpId,onSuccess,onClose,data}:IChangePDProps){


    const dataUpdate = useRef<IUpdateItem>()
    const [ldrUpdate,rsUpdate,exUpdate] = useApiQuery("/pd/update","post",dataUpdate);



    const [pdData,setPdData] = useState(data ? data : {
        family:"-",
        name: "-",
        middleName: "-",
        birthDate:"0000-00-00",
        depart:"-",
        docDate: "0000-00-00",
        serial: "-",
        number: "-"
    } )


    const refFamily = useRef<IRefInputItem>(null)
    const refName = useRef<IRefInputItem>(null)
    const refMiddleName = useRef<IRefInputItem>(null)

    const refBirthDay = useRef<IRefInputItem>(null)
    const refSerial = useRef<IRefInputItem>(null)
    const refNumber = useRef<IRefInputItem>(null)

    const refDocDate = useRef<IRefInputItem>(null)
    const refDepart = useRef<IRefInputItem>(null)

    const refState = useRef<ErrorLineItemRef>(null)


    const upRegister = (str: string):string =>    {
        if(! str) return ""
        str = str?.trim()
        const ms = str?.split(' ')
        const x = ms?.reduce((acc,item)=>{
            item = item?.toLowerCase()
            acc+= item?.length ? (item.charAt(0).toUpperCase() + item.slice(1)) + " ": ""
            return acc
        },"")

        return x.trim()
    }

    const normDate = (str:string):{
        iso:string|null
        text:string
    }=>{
        if(!str) return {text:"",iso:null}
        const x = str?.replace(/[^0-9]/uig,'')
        if(!x?.match(/[0-9]{8}/ui)) return {text:str,iso:null}
        const year = x?.substring(4)
        const day = x?.substring(0,2)
        const month = x?.substring(2,4)
        const isoDate = `${year}-${month}-${day}`
        const dt = moment(isoDate).format("DD.MM.YYYY")
        // console.log(`mormDate ${dt} ${isoDate}`)

        return {
            text: dt,
            iso: isoDate
        }

    }


    const handleUpdate = () =>{

        if(refState.current)refState.current.clear()

        if(refFamily.current && !refFamily.current.validate()){
            if(refState.current)refState.current.show("Фамилия не корректна",true,5000)
            return
        }
        if(refName.current && !refName.current.validate()){
            if(refState.current)refState.current.show("Имя не корректно",true,5000)
            return
        }

        if(refBirthDay.current && !refBirthDay.current.validate()){
            if(refState.current)refState.current.show("Дата рождения не корректна",true,5000)
            return
        }

        if(refSerial.current && !refSerial.current.validate()){
            if(refState.current)refState.current.show("Серия паспорта не корректна",true,5000)
            return
        }

        if(refNumber.current && !refNumber.current.validate()){
            if(refState.current)refState.current.show("Номер паспорта не корректен",true,5000)
            return
        }

        if(refDepart.current && !refDepart.current.validate()){
            if(refState.current)refState.current.show("Код департамента паспорта не корректен",true,5000)
            return
        }

        if(refDocDate.current && !refDocDate.current.validate()){
            if(refState.current)refState.current.show("Дата выдачи паспорта не корректна",true,5000)
            return
        }

        const xBirthDate = normDate(pdData?.birthDate)
        const xDocDate = normDate(pdData?.docDate)

        if(xBirthDate?.iso === null){
            if(refState.current)refState.current.show("Дата рождения не корректна",true,5000)
            return
        }

        if(xDocDate?.iso === null){
            if(refState.current)refState.current.show("Дата выдачи паспорта не корректна",true,5000)
            return
        }


        dataUpdate.current = {
            dkpId: dkpId,
            family: pdData?.family,
            name: pdData?.name,
            middleName: pdData?.middleName ? pdData?.middleName : undefined,
            birthDate: new Date(xBirthDate.iso),

            serial: pdData?.serial,
            number: pdData?.number,

            depart: pdData?.depart,

            docDate: new Date(xDocDate.iso),
        }

        console.log(dataUpdate.current)
        exUpdate().then((e)=>{
            if(e?.success){
                if(refState.current)refState.current.show("Данные обновлены",false,0)
                if(onSuccess)onSuccess()
                return

            }
            if(refState.current)refState.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера",true,5000)

        })



    }



    return(
        <ModalWindow>
            <MainFormTemplate title={`Смена персональных данных клиента`} maxWidth={"1000px"} background={"white"} load={ldrUpdate}>
                <div className={"row align-items-center justify-content-start d-flex my-1"}>
                    <div className={["col-xl-4  col-lg-4  col-md-6 col-xs-12", styles.lsFont].join(' ')}>
                        <InputItemLight
                            val={pdData?.family ? pdData?.family  : "-"}
                            ref={refFamily}

                            mode={"ie"}
                            info={"Фамилия"}
                            titleColNumber={4}
                            title={"Фамилия"}
                            regExp={/[а-я-\s]{2,}/ui}
                            onChange={(e)=>{
                                if(pdData)setPdData({...pdData,family: (e)})
                            }}
                            onBlur={(e)=>{
                                if(pdData)setPdData({...pdData,family: upRegister(e)})

                            }}

                        ></InputItemLight>
                    </div>
                    <div className={["col-xl-4  col-lg-4  col-md-6 col-xs-12", styles.lsFont].join(' ')}>
                        <InputItemLight
                            val={pdData?.name ? pdData?.name  : "-"}
                            ref={refName}
                            mode={"ie"}
                            info={"Имя"}
                            titleColNumber={4}
                            title={"Имя"}
                            regExp={/[а-я-\s]{2,}/ui}
                            onChange={(e)=>{
                                if(pdData)setPdData({...pdData,name: (e)})
                            }}
                            onBlur={(e)=>{
                                if(pdData)setPdData({...pdData,name: upRegister(e)})

                            }}
                        ></InputItemLight>
                    </div>
                    <div className={["col-xl-4  col-lg-4  col-md-6 col-xs-12", styles.lsFont].join(' ')}>
                        <InputItemLight
                            val={pdData?.middleName ? pdData?.middleName  : "-"}
                            mode={"ie"}
                            info={"Отчество"}
                            titleColNumber={4}

                            title={"Отчество"}
                            canEmpty={true}
                            ref={refMiddleName}
                            regExp={/([а-я-\s]{2,})|(^$)/ui}
                            onChange={(e)=>{
                                if(pdData)setPdData({...pdData,middleName: (e)})
                            }}
                            onBlur={(e)=>{
                                if(pdData)setPdData({...pdData,middleName: upRegister(e)})

                            }}
                        ></InputItemLight>
                    </div>
                </div>
                <div className={"row align-items-center justify-content-start d-flex my-1"}>
                    <div className={["col-xl-4  col-lg-4  col-md-6 col-xs-12", styles.lsFont].join(' ')}>
                        <InputItemLight
                            val={pdData?.birthDate ? pdData?.birthDate : "-"}
                            ref={refBirthDay}
                            mode={"ie"}
                            info={"Дата рожд."}
                            titleColNumber={5}

                            title={"Дата рожд."}
                            placeHolder={"XX.XX.XXXX"}
                            maxLen={10}


                            regExp={/^[0-9]{2}\.[0-9]{2}\.[0-9]{4}$/ui}
                            inputType={"numeric"}
                            onChange={(e)=>{
                                const x = normDate(e)
                                if(pdData)setPdData({...pdData,birthDate: x?.text})
                            }}
                        ></InputItemLight>
                    </div>
                    <div className={["col-xl-4  col-lg-4  col-md-6 col-xs-12", styles.lsFont].join(' ')}>
                        <InputItemLight
                            val={pdData?.serial ? pdData?.serial : "-"}
                            ref={refSerial}
                            mode={"ie"}
                            info={"Серия"}
                            titleColNumber={4}

                            maxLen={4}
                            title={"Серия"}
                            placeHolder={"XXXX"}

                            regExp={/^[0-9]{4}$/ui}
                            inputType={"numeric"}
                            onChange={(e)=>{
                                if(pdData)setPdData({...pdData,serial: e.trim()})
                            }}
                        ></InputItemLight>
                    </div>
                    <div className={["col-xl-4  col-lg-4  col-md-6 col-xs-12", styles.lsFont].join(' ')}>
                        <InputItemLight
                            val={pdData?.number ? pdData?.number : "-"}
                            ref={refNumber}
                            mode={"ie"}
                            info={"Номер"}
                            titleColNumber={4}

                            maxLen={6}

                            title={"Номер"}
                            placeHolder={"XXXXXX"}

                            regExp={/^[0-9]{6}$/ui}
                            inputType={"numeric"}
                            onChange={(e)=>{
                                if(pdData)setPdData({...pdData,number: e.trim()})
                            }}
                        ></InputItemLight>
                    </div>
                </div>
                <div className={"row align-items-center justify-content-start d-flex my-1"}>
                    <div className={["col-xl-4  col-lg-4  col-md-6 col-xs-12", styles.lsFont].join(' ')}>
                        <InputItemLight
                            val={pdData?.docDate ? pdData?.docDate : "-"}
                            ref={refDocDate}
                            mode={"ie"}
                            info={"Дата выдачи."}
                            titleColNumber={5}

                            title={"Дата выдачи."}
                            placeHolder={"XX.XX.XXXX"}
                            maxLen={10}


                            regExp={/^[0-9]{2}\.[0-9]{2}\.[0-9]{4}$/ui}
                            inputType={"numeric"}
                            onChange={(e)=>{
                                const x = normDate(e)
                                if(pdData)setPdData({...pdData,docDate: x?.text})
                            }}
                        ></InputItemLight>
                    </div>
                    <div className={["col-xl-4  col-lg-4  col-md-6 col-xs-12", styles.lsFont].join(' ')}>
                        <InputItemLight
                            val={pdData?.depart ? pdData?.depart : "-"}
                            ref={refDepart}
                            mode={"ie"}
                            info={"Код департамента"}
                            titleColNumber={4}

                            maxLen={6}
                            title={"Код"}
                            placeHolder={"XXXXXX"}

                            regExp={/^[0-9]{6}$/ui}
                            inputType={"numeric"}
                            onChange={(e)=>{
                                if(pdData)setPdData({...pdData,depart: e.trim()})
                            }}
                        ></InputItemLight>
                    </div>
                </div>
                <div className={"row my-2"}>
                    <ErrorLineItem ref={refState} height={"30px"}/>
                </div>

                <div className={"row my-2"}>
                    <div className={"d-flex col-12"}>
                        <ButtonContainer clsCont={styles.btnCont}>
                            <button type="button" className="btn btn-secondary "
                                onClick={handleUpdate}
                            >Обновить</button>

                            <button type="button" className="btn btn-secondary "
                                    onClick={onClose}
                            >Выход</button>


                        </ButtonContainer>

                    </div>

                </div>
            </MainFormTemplate>
        </ModalWindow>
    )
}